import Vue from 'vue'
import Vuex, { StoreOptions } from 'vuex'

// NOTE: Root Datas
import { RootState } from './types'
const { state } = require('./state')
import { actions } from './actions'
import { mutations } from './mutations'
import { getters } from './getters'

// NOTE: Load Modules
import auth from './modules/auth'
import scheduling from './modules/scheduling'

Vue.use(Vuex)

const store: StoreOptions<RootState> = {
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters,
  modules: {
    auth: auth,
    scheduling: scheduling
  }
}

export default new Vuex.Store<RootState>(store)
